/* Scroll parallax: translate [data-parallax] elements at a fraction of scroll.
   rAF-throttled, only while near the viewport, disabled under reduced motion. */
(function () {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  let items = [];
  let ticking = false;

  function collect() {
    items = Array.from(document.querySelectorAll("[data-parallax]")).map((el) => ({
      el,
      speed: parseFloat(el.dataset.parallaxSpeed || "0.1"),
      base: el.getBoundingClientRect().top + window.scrollY,
      section: el.closest("section") || el,
    }));
  }

  function update() {
    const y = window.scrollY;
    const vh = window.innerHeight;
    for (const it of items) {
      const rect = it.section.getBoundingClientRect();
      if (rect.bottom < -vh || rect.top > vh * 1.5) continue; // skip far-off sections
      const offset = (y - it.base) * it.speed;
      it.el.style.transform = `translate3d(0, ${offset.toFixed(1)}px, 0)`;
    }
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  function init() {
    collect();
    if (!items.length) return;
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", () => {
      collect();
      update();
    }, { passive: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", () => {
    collect();
    update();
  });
})();
